import {propOr} from 'ramda';

import {TelephonyCall} from '@dms/api/settings';

const NOT_FOUND_STATUS = 404;

/**
 * An outbound call that never dialled the customer: the backend never stores it as communication,
 * so it has nothing to pair or note (its note and pairing writes answer 404).
 */
export const isUnkeptTelephonyCall = (call: TelephonyCall) =>
  call.direction === 'outbound' &&
  (call.outcome === 'user_not_reached' || call.outcome === 'not_confirmed');

/** The call read failed because the backend no longer has the call. */
export const isTelephonyCallNotFound = (error: unknown) =>
  propOr(null, 'status', error) === NOT_FOUND_STATUS;
